(function () {
  'use strict';
  var config = window.cbMarketConfig;
  if (!config || (config.country !== 'KW' && config.country !== 'SA')) return;
  function rate() {
    var currency = window.Shopify && window.Shopify.currency;
    var live = currency && Number(currency.rate);
    return currency && currency.active === 'KWD' && Number.isFinite(live) && live > 0 ? live : config.kwRate;
  }
  function format(value, rounding) {
    var fils = Number(value) * 1000;
    if (!Number.isFinite(fils) || fils < 0) return '';
    fils = rounding === 'ceil' ? Math.ceil(fils - 1e-9) : rounding === 'floor' ? Math.floor(fils + 1e-9) : Math.round(fils);
    return 'KWD ' + (fils / 1000).toFixed(3);
  }
  function aed(value, rounding) { return format(Number(value) * rate(), rounding); }
  function presentment(cents, currency, divisor) {
    if (currency === 'KWD') {
      var amount = Number(cents), parts = divisor == null ? 1 : Number(divisor);
      if (!Number.isSafeInteger(amount) || amount < 0 || !Number.isSafeInteger(parts) || parts <= 0) return '';
      var numerator = amount * 20 + parts, denominator = parts * 2;
      if (!Number.isSafeInteger(numerator) || !Number.isSafeInteger(denominator)) return '';
      var fils = Math.floor(numerator / denominator);
      return 'KWD ' + Math.floor(fils / 1000) + '.' + ('000' + (fils % 1000)).slice(-3);
    }
    var value = Number(cents) / 100 / (divisor || 1);
    return currency === 'AED' ? aed(value) : '';
  }
  function html(cents, currency) {
    var value = presentment(Number(cents), currency || config.currency);
    return value ? '<span class="money" hidden aria-hidden="true"></span><span class="cb-kw-money" dir="ltr">' + value + '</span>' : '';
  }
  function hookThemeMoney() {
    if (config.country !== 'KW' || !window.theme) return;
    if (!window.theme.Currency) {
      var descriptor = Object.getOwnPropertyDescriptor(window.theme, 'Currency');
      if (!descriptor || descriptor.configurable) Object.defineProperty(window.theme, 'Currency', {
        configurable: true, enumerable: true,
        get: function () { return undefined; },
        set: function (currency) {
          Object.defineProperty(window.theme, 'Currency', { value: currency, configurable: true, enumerable: true, writable: true });
          hookThemeMoney();
        }
      });
      return;
    }
    if (window.theme.Currency.formatMoney && window.theme.Currency.formatMoney.cbKwd) return;
    var formatter = function (cents) { return html(typeof cents === 'string' ? cents.replace('.', '') : cents); };
    formatter.cbKwd = true;
    window.theme.Currency.formatMoney = formatter;
  }
  function shipping() {
    var text = config.shipping[config.locale === 'ar' ? 'ar' : 'en'];
    Object.keys(config.amounts).forEach(function (key) { text = text.replace('{' + key + '}', aed(config.amounts[key], config.rounding[key])); });
    return text;
  }
  function update() {
    if (config.country !== 'KW') return;
    var cart = window.cbMarketCart || { total_price: config.total, currency: config.currency };
    var currency = typeof cart.currency === 'string' ? cart.currency : cart.currency && cart.currency.iso_code;
    document.querySelectorAll('[data-cb-kw-shipping]').forEach(function (el) {
      var text = shipping(); if (el.textContent !== text) el.textContent = text;
    });
    document.querySelectorAll('[data-cb-kw-product-instalment]').forEach(function (el) {
      var text = presentment(Number(el.getAttribute('data-cb-kw-cents')), el.getAttribute('data-cb-kw-currency') || config.currency, Number(el.getAttribute('data-cb-kw-product-instalment')));
      if (text && el.textContent !== text) el.textContent = text;
    });
    document.querySelectorAll('[data-cb-kw-instalment]').forEach(function (el) {
      var text = presentment(cart.total_price, currency || config.currency, Number(el.getAttribute('data-cb-kw-instalment')));
      if (text && el.textContent !== text) el.textContent = text;
    });
  }
  window.cbKwd = { fromAED: aed, presentment: presentment, html: html, shipping: shipping, update: update };
  hookThemeMoney();
  document.addEventListener('DOMContentLoaded', hookThemeMoney);
  document.addEventListener('shopify:section:load', hookThemeMoney);
  if (config.country !== 'KW') return;
  document.addEventListener('variant:change', function (event) {
    var detail = event.detail || {}, variant = detail.variant;
    if (!variant || !Number.isSafeInteger(variant.price)) return;
    document.querySelectorAll('[data-cb-kw-product-instalment]').forEach(function (el) {
      if (detail.sectionId && String(detail.sectionId) !== el.getAttribute('data-cb-kw-section')) return;
      var ids = (el.getAttribute('data-cb-kw-variants') || '').split(',');
      if (ids.indexOf(String(variant.id)) === -1) return;
      el.setAttribute('data-cb-kw-cents', String(variant.price));
    });
    update();
  });
  document.addEventListener('cb:cart-verified', update);
  ['DOMContentLoaded', 'shopify:section:load', 'currency:change'].forEach(function (name) { document.addEventListener(name, update); });
  window.addEventListener('pageshow', update);
  var queued = false;
  new MutationObserver(function () {
    if (queued) return; queued = true;
    queueMicrotask(function () { queued = false; update(); });
  }).observe(document.documentElement, { childList: true, characterData: true, subtree: true });
  update();
})();
